module.exports = __webpack_public_path__ + "static/media/acto_de_grado_3.7ce28651.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/acto_de_grado_3.jpg
// module id = 910
// module chunks = 0